import React, { createContext, useContext, useMemo, useState, useEffect } from 'react';
import { getLocale } from './locale';
import { getTranslations } from './translations';

const LocaleContext = createContext({ locale: 'en', isZh: false, t: null });

export function LocaleProvider({ children }) {
  const [locale, setLocale] = useState(() => getLocale());
  useEffect(() => {
    setLocale(getLocale());
  }, []);
  const isZh = locale === 'zh';
  const t = useMemo(() => getTranslations(locale), [locale]);
  const value = useMemo(() => ({ locale, isZh, t }), [locale, isZh, t]);
  return (
    <LocaleContext.Provider value={value}>
      {children}
    </LocaleContext.Provider>
  );
}

export function useLocale() {
  const ctx = useContext(LocaleContext);
  if (!ctx.t) return { locale: 'en', isZh: false, t: getTranslations('en') };
  return ctx;
}
